import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// This is potential security threat. Confirm with other team members it's ok to use this.
@Pipe({
  name: 'rtSafeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string, ...args: any[]): SafeHtml {
    // eslint-disable-next-line ban/ban
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
